import type {PageRouteConfig} from '@router';

import UnfairPrice from 'modules/Chortke/UnfairPrice/UnfairPrice';

export function createChortkeUnfairPriceRoute(): PageRouteConfig {
  return {
    element: <UnfairPrice />,
    layout: {
      title: 'قیمت غیرمنصفانه',
      hasNavigate: false,
      hasBack: true,
      hasHeader: true,
      link: -1
    }
  };
}
